/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataOnSubmit(props) {
  return function onSubmit() {
    if (typeof props.onClick === 'function') {
      return props.onClick()
    }
  }
}
